module.exports = __webpack_public_path__ + "img/illus_wizard_1.e52f93ca.png";